export const GET_CAS_NUMBER_LIST = 'GET_CAS_NUMBER_LIST';
export const GET_CAS_NUMBER_LIST_SUCCESS = `${GET_CAS_NUMBER_LIST}/SUCCESS`;
export const GET_CAS_NUMBER_LIST_FAILURE = `${GET_CAS_NUMBER_LIST}/FAILURE`;

export default {
  GET_CAS_NUMBER_LIST,
  GET_CAS_NUMBER_LIST_SUCCESS,
  GET_CAS_NUMBER_LIST_FAILURE
};
